<template>
  <eb-panel class="rule-answer-view-type-item">
    <eb-panel-header class="panel-header" slot="header">
      <span slot="title">{{ ruleTypeItemIndex +1 }} {{ruleTypeItem.ruleType}}</span>
    </eb-panel-header>
    <div slot="body">
      <ProjRuleAnswerViewListDigitalItem v-for="(item, $index) in ruleTypeItem.ruleItem" :key="$index" :ruleDigitalItem="item"
        :ruleDigitalItemIndex="$index" :ruleTypeItemIndex="ruleTypeItemIndex" />
    </div>
  </eb-panel>
</template>
<script>
import EbPanel from '@/components/common/panel/eb-panel';
import EbPanelHeader from '@/components/common/panel/eb-panel-header';
import ProjRuleAnswerViewListDigitalItem from './ProjRuleAnswerViewListDigitalItem';

export default {
  name: 'ProjRuleAnswerEditListTypeItem',
  components: {
    EbPanel,
    EbPanelHeader,
    ProjRuleAnswerViewListDigitalItem
  },
  filters: {},
  props: {
    ruleTypeItem: {
      type: Object,
      required: true
    },
    ruleTypeItemIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
.rule-answer-view-type-item {
  .panel-body {
    overflow: visible !important;
  }
}
</style>
